import { pipe } from 'ramda';

import { buildCmsUrl, getResponseCMS } from './base';
import { request } from '@/api/base';
import { getResponseCamelization } from '@/helpers/api';
import { isCMSV3 } from '@/helpers/conf';

export interface TopSpotGame {
  startDate: string;
  endDate: string;
  vip1Goal: number;
  vip2Goal: number;
  vip3Goal: number;
  superVip1Goal: number;
  superVip2Goal: number;
  superVip3Goal: number;
  pvipText: string;
  gameCompleteText: string;
}

export const topSpotGameCMSV3 = (lang: string) =>
  request<TopSpotGame>({
    url: buildCmsUrl({ path: 'top-spot-game', lang }),
  });

export const topSpotGameCMSV4 = (lang: string) =>
  request<TopSpotGame>({
    url: buildCmsUrl({ path: 'top-spot-game', lang }),
    transformResponse: pipe(
      getResponseCamelization,
      getResponseCMS<TopSpotGame>
    ),
  });

export const topSpotGameCMS = isCMSV3 ? topSpotGameCMSV3 : topSpotGameCMSV4;
